import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const subscribersEvolutionPercentageConfig: KpiType<
    typeof DefaultLoader,
    typeof KPIDefault
> = {
    name: 'kpi.youtube.subscribers_evolution_percentage',
    id: 'subscribers_evolution_percentage',
    icon: {
        name: 'followers',
        style: colors.blue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    tooltip: 'kpi.youtube.tooltip_subscribers_evolution_percentage',
    size: SIZE_33,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: DefaultLoader,
    element: KPIDefault
};
